import { faEdit, faInfoCircle } from "@fortawesome/free-solid-svg-icons"
import { Fragment, useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import Backdrop from "../../../Backdrop"
import Filter from "./desktop/filter"
import Resort from './desktop/resort'
import InfoIcon from "../../../InfoIcon"


export default function DesktopComponent() {


    const [desktopItems, setDesktopItems] = useState()


    let filteredfavorites = useSelector((state) => state.favorite.filteredFavorites)

    let dispatch = useDispatch()



    let statefavorites = useSelector(state => state.favorite.favorites)


    useEffect(() => {

        let items = []
        let favorites = filteredfavorites ?? statefavorites

        if (favorites && Object.keys(favorites).length > 0) {

            favorites.forEach((favorite) => {

                items.push(<DesktopItem key={favorite.id} favorite={favorite} />)

            })
        }
        setDesktopItems(items)



    }, [filteredfavorites, statefavorites])


    if (!desktopItems) {
        return <Skeleton count={50} />
    }

    return <Fragment>
        <Filter>

            <table className="table table-striped table-bordered" >
                <thead>
                    <tr>

                        <th>ProductTitle <Resort type='ptitle' /></th>

                        <th>CreatedOn <Resort type='created_on' /></th>
                    </tr>
                </thead>
                <tbody>
                    {desktopItems}
                </tbody>
            </table>
        </Filter>
        <Backdrop />

    </Fragment>
}


function DesktopItem(props) {
    const { favorite } = props
    
    return <Fragment>

        <tr>

           
            <td>
                <Link to={`/products/${favorite.product_id}`} >{favorite.ptitle}</Link>

            </td>
           
            <td>
                {favorite.created_on}
            </td>

        </tr>

    </Fragment>

}